/**
 * reCAPTCHA v3 — スクリプト読込とトークン取得
 */

export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';

let scriptLoadPromise = null;

export function loadRecaptchaScript() {
  if (!RECAPTCHA_SITE_KEY) return Promise.resolve(false);
  if (typeof window !== 'undefined' && window.grecaptcha) return Promise.resolve(true);
  if (scriptLoadPromise) return scriptLoadPromise;

  scriptLoadPromise = new Promise((resolve) => {
    if (document.getElementById('recaptcha-v3-script')) {
      resolve(Boolean(window.grecaptcha));
      return;
    }
    const script = document.createElement('script');
    script.id = 'recaptcha-v3-script';
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });

  return scriptLoadPromise;
}

/**
 * @param {string} action - reCAPTCHA v3 action 名
 * @returns {Promise<string>} トークン（未設定時は空文字）
 */
export async function getRecaptchaToken(action) {
  if (!RECAPTCHA_SITE_KEY) return '';
  await loadRecaptchaScript();
  if (!window.grecaptcha) return '';
  try {
    return await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
  } catch {
    return '';
  }
}
